function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M162.643,247.503c-5.719,0.084-9.384,0.654-11.549,1.213v75.774c2.16,0.554,5.674,0.617,8.849,0.68 c23.382,0.623,38.908-12.413,38.908-40.666C199.019,259.933,184.886,247.164,162.643,247.503z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M359.036,537.78c0.771,0.042,1.551,0.111,2.342,0.111h178.2c20.84,0,37.8-16.96,37.8-37.801V86.994 c0-20.838-16.96-37.8-37.8-37.8h-178.2c-0.786,0-1.571,0.077-2.342,0.113V0L11.222,46.417v494.564L359.036,588.6V537.78z  M539.578,516.301h-178.2c-0.797,0-1.571-0.127-2.342-0.242v-162.08c37.131-6.417,88.694-11.274,133.292-0.796l5.278,10.235 c21.289,40.253,44.028,39.989,52.813,38.006c2.015-0.453,3.101-0.959,3.101-0.959l1.182-0.628c0.4-0.253,0.712-0.575,1.075-0.849 v101.112C555.777,509.029,548.511,516.301,539.578,516.301z M374.15,334.768c27.906-34.034,50.456-65.807,64.979-87.325 l0.053,0.119l0.158-0.243c11.401,24.036,30.196,61.214,43.137,86.59l-0.042-0.011l0.443,0.85 c-36.798-6.286-76.312-3.992-108.812,0.501l0.475-0.554L374.15,334.768z M439.794,175.958c1.118-1.972,2.753-2.494,5.685-2.365 c0.053,0.005,5.875,0.387,8.047,4.375c1.318,2.375,3.228,9.908-7.045,28.278h-0.011c0,0-1.329,2.21-3.828,6.199 C436.883,192.222,437.263,180.413,439.794,175.958z M514.107,359.812c10.557,4.061,20.039,9.065,28.339,14.981 c2.384,3.386,4.588,8.259,4.188,10.558c-0.021,0.111-0.042,0.222-0.105,0.332C543.121,386.311,529.568,386.733,514.107,359.812z  M361.378,70.798h178.2c8.933,0,16.199,7.27,16.199,16.2v278.614c-0.506-0.723-0.943-1.318-1.202-1.64l-0.686-0.887l-0.896-0.664 c-13.827-10.094-30.491-17.872-49.581-23.129c-13.61-26.578-41.797-81.974-53.646-107.916c6.861-10.568,10.547-16.728,10.716-17.01 c10.689-19.056,13.025-33.932,7.114-44.426c-5.358-9.498-16.031-12.351-21.484-12.532c-8.817-0.401-16.337,3.37-20.419,10.552 c-6.223,10.966-4.936,30.175,3.86,57.056c0.391,1.242,1.018,2.834,1.846,4.838c-14.091,21.312-39.656,58.174-72.367,97.767V71.036 C359.807,70.922,360.576,70.798,361.378,70.798z M100.311,290.957c-8.224,8.158-20.313,11.718-34.267,11.591 c-3.069-0.031-5.843-0.221-7.986-0.569v39.698l-22.842-0.633V232.659c7.056-1.469,17.041-2.689,31.292-3.035 c14.562-0.356,25.109,2.402,32.221,8.277c6.858,5.579,11.485,14.958,11.485,26.087 C110.214,275.128,106.694,284.573,100.311,290.957z M207.549,331.715c-12.337,10.066-30.881,14.454-53.135,13.832 c-13.11-0.375-22.307-1.477-28.506-2.5V230.563c9.152-1.743,21.188-2.888,34.035-3.201c21.676-0.53,35.955,3.159,47.271,11.538 c12.287,8.98,20.084,23.599,20.084,44.745C227.298,306.566,218.977,322.233,207.549,331.715z M245.249,226.194l76.842-1.835v23.106 l-48.877,0.709v27.891l45.628-0.113v22.884l-45.628-0.316v49.096l-27.973-0.771v-120.65H245.249z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.745,248.622c-4.77,0.074-7.992,0.614-9.683,1.139v32.777c1.98,0.498,4.438,0.665,7.834,0.665 c12.551,0.01,20.363-6.837,20.363-18.344C86.26,254.506,79.534,248.432,67.745,248.622z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgPdfExt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "588.6px",
    height: "588.6px",
    viewBox: "0 0 588.6 588.6",
    style: {
      enableBackground: "new 0 0 588.6 588.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfExt);
export default __webpack_public_path__ + "static/media/pdf_ext.363d45d7.svg";
export { ForwardRef as ReactComponent };